export function setTitle(title) {
  const suffix = "Spryvibe |";
  document.title = `${suffix} ${title}`;
}